import { getConfig } from '@/config/runtime'

/**
 * Reads an image URL field, switching to its CloudFront-backed `*Cf` mirror
 * once files have been migrated off Filestack to S3.
 */
export const migratedImage = (source: any, field: string): string | undefined => {
  const key = getConfig().FILES_MIGRATED ? `${field}Cf` : field
  return source?.[key] || undefined
}
